import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { DataserviceService } from '../dataservice.service';
import { NzMessageService } from 'ng-zorro-antd/message';

const disallowSelfEmail = (own: string) => (c: AbstractControl): ValidationErrors | null =>
  c.value && own && c.value.trim().toLowerCase() === own.trim().toLowerCase()
    ? { selfEmail: true }
    : null;

const disallowSelfPhone = (own: string) => {
  const norm = (v: string) => {
    const d = (v || '').replace(/\D/g, '');
    return d.length === 11 && d.startsWith('1') ? d.slice(1) : d;
  };
  const ownNorm = norm(own);
  return (c: AbstractControl): ValidationErrors | null =>
    norm(c.value) === ownNorm ? { selfPhone: true } : null;
};

@Component({
  selector: 'app-ziply-welcome-call',
  templateUrl: './ziply-welcome-call.component.html',
  styleUrl: './ziply-welcome-call.component.css'
})

export class ZiplyWelcomeCallComponent {
  currentUser: any;
  welcomeCallForm: FormGroup;
  loading: boolean = false;
  pinSent: boolean = false;
  wcId: any;
  countdown = 0

  constructor(
    private data: DataserviceService,
    private message: NzMessageService
  ) {
    this.welcomeCallForm = new FormGroup({
      first_name: new FormControl(null, [Validators.required]),
      last_name: new FormControl(null, [Validators.required]),
      phone: new FormControl(null, [Validators.required]),
      email: new FormControl(null, [Validators.required, Validators.email]),
      pin: new FormControl(null),
      repFirst: new FormControl(null),
      repLast: new FormControl(null)
    });
  }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('user')!);
    this.welcomeCallForm.get('repFirst')?.setValue(this.currentUser.first_name);
    this.welcomeCallForm.get('repLast')?.setValue(this.currentUser.last_name);

    const emailCtrl = this.welcomeCallForm.get('email');
    const phoneCtrl = this.welcomeCallForm.get('phone');
   
    if (emailCtrl && this.currentUser?.email) {
      emailCtrl.setValidators([Validators.required, Validators.email, disallowSelfEmail(this.currentUser.email)]);
      emailCtrl.updateValueAndValidity();
    }

    if (phoneCtrl && this.currentUser?.phone) {
      phoneCtrl.setValidators([Validators.required, disallowSelfPhone(this.currentUser.phone)]);
      phoneCtrl.updateValueAndValidity();
    }
  }

  resetForm() {
    this.welcomeCallForm.reset();
    this.pinSent = false;
  }

  sendPin() {
    if(this.welcomeCallForm.valid) {
      if(this.countdown == 0) {
        this.loading = true;
  
        this.data.postData(this.welcomeCallForm.value, 'welcome-call/ziply-send-pin')
          .subscribe({
            next: (res: any) => {
              if(res?.pinSent) {
                this.createMessage('success', `Pin sent! Please have the customer check their email`);
                this.pinSent = true;
                this.loading = false;
                this.wcId = res?.wcId;
                this.startCountdown(45)
              }else if(res?.alreadyCompleted) {
                this.createMessage('success', `Welcome call already completed for this customer!`);
                this.loading = false;
              }
            }
          })
      }
    }else {
      if(this.countdown == 0) {
        this.createMessage('warning', `Please complete the form accurately, and do not include any personal information of your own.`);
      }
    }
  }

  confirmPin() {
    this.loading = true;
    let obj = {
      pin: this.welcomeCallForm.get('pin')?.value,
      wcId: this.wcId
    }

    this.data.postData(obj, 'welcome-call/ziply-confirm-pin')
      .subscribe({
        next: (r: any) => {
          if(r?.pinConfirmed) {
            this.createMessage('success', `Welcome call completed!`);
            this.pinSent = false;
            this.welcomeCallForm.reset()
          }else {
            this.createMessage('error', `Pin is invalid or expired!`);
          }
          this.loading = false;
        },
        error: () => {
          this.loading = false;
          this.createMessage('error', `Failed to confirm pin`);
        }
    });
  }

  startCountdown(seconds: number) {
    this.countdown = seconds;
  
    const timer = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        clearInterval(timer);
      }
    }, 1000);
  }

  createMessage(type: string, message: string): void {
    // this.message.create(type, message);
    alert(message)
  }
}
